import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { setLenis, scrollTop } from "@/lib/smooth";
import { ChatWidget } from "@/components/ChatWidget";
import Home from "@/pages/Home";
import PartitaIva from "@/pages/PartitaIva";
import Aziende from "@/pages/Aziende";
import Privati from "@/pages/Privati";
import Offerte from "@/pages/Offerte";
import Usato from "@/pages/Usato";
import NltUsato from "@/pages/NltUsato";
import UsatoDetail from "@/pages/UsatoDetail";
import ModelPage from "@/pages/ModelPage";
import GuidePage from "@/pages/GuidePage";
import BlogPost, { BlogIndex } from "@/pages/Blog";
import PartnerPage from "@/pages/PartnerPage";
import ChiSiamo from "@/pages/ChiSiamo";
import Grazie from "@/pages/Grazie";
import AssistenteContenuti from "@/pages/AssistenteContenuti";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollTop();
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/noleggio-lungo-termine-partita-iva/" element={<PartitaIva />} />
          <Route path="/noleggio-lungo-termine-aziende/" element={<Aziende />} />
          <Route path="/noleggio-lungo-termine-privati/" element={<Privati />} />
          <Route path="/offerte/" element={<Offerte />} />
          <Route path="/noleggio-lungo-termine-usato/" element={<NltUsato />} />
          <Route path="/usato/" element={<Usato />} />
          <Route path="/usato/marca/:marca/" element={<Usato />} />
          <Route path="/usato/categoria/:categoria/" element={<Usato />} />
          <Route path="/usato/:slug/" element={<UsatoDetail />} />
          <Route path="/offerte/:marca/:modello/" element={<ModelPage />} />
          <Route path="/guide/deducibilita-noleggio-auto-partita-iva/" element={<GuidePage />} />
          <Route path="/guide/" element={<BlogIndex />} />
          <Route path="/guide/:slug/" element={<BlogPost />} />
          <Route path="/partner/:rete/" element={<PartnerPage />} />
          <Route path="/chi-siamo/" element={<ChiSiamo />} />
          <Route path="/grazie/" element={<Grazie />} />
          <Route path="/assistente-contenuti/" element={<AssistenteContenuti />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <ChatWidget />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
